import { useEffect } from 'react';
import isEqual from 'lodash-es/isEqual';
import { pendo } from '@frontend/tracking';
import { usePanelStore } from './store';

interface Panel {
  id: string;
  placementLocation: 'tray' | 'page';
}

const extractPanelInfo = (panels: Panel[]) => {
  let trayCount = 0;
  let pageCount = 0;

  for (const panel of panels) {
    if (panel.placementLocation === 'tray') {
      trayCount++;
    } else if (panel.placementLocation === 'page') {
      pageCount++;
    }
  }

  return { trayCount, pageCount };
};

export const PanelEnginePendoTrack = () => {
  useEffect(() => {
    if (import.meta.env.PROD) {
      const unsubscribe = usePanelStore.subscribe(
        (state) => state.panels,
        (currentPanels, previousPanels) => {
          if (currentPanels.length === 0) return;
          if (isEqual(currentPanels, previousPanels)) return;

          const previousIds = previousPanels.map((p) => p.id);
          const currentIds = currentPanels.map((p) => p.id);
          const hasChangedPanels = !isEqual(previousIds, currentIds);

          const previous = extractPanelInfo(previousPanels);
          const current = extractPanelInfo(currentPanels);

          pendo.track('panel-engine-panel-change', {
            countAllPrevious: previousIds.length,
            countAllCurrent: currentIds.length,
            countTrayPrevious: previous.trayCount,
            countTrayCurrent: current.trayCount,
            countPagePrevious: previous.pageCount,
            countPageCurrent: current.pageCount,
            hasChangedPanels,
          });
        }
      );

      return unsubscribe;
    }

    return;
  }, []);

  return null;
};

export default PanelEnginePendoTrack;
